import { GET_ADMIN_OVERVIEW } from '../../config/endpoints';
import api from '../../config/setAuthHeader';

export const getAdminOverviewAnalytics = async () => {
  const { data } = await api.get(`${GET_ADMIN_OVERVIEW}`);
  return data;
};
